import _ from 'lodash';
import { lsErrorService, lsScheduleHelpers } from 'ls-vue-common';
import {
  ScheduleServiceItemIconStatusConstants,
  ScheduleServiceItemIconStatusPartnersConstants,
} from './LsScheduleServiceItemConstants';

const getScheduleServiceItemDisplayValues = ({ schedule }) => {
  const scheduleStatus = lsScheduleHelpers.getScheduleStatus({ schedule });
  let iconAndStatus = schedule.isLtrsProvidedByPartner
    ? _.cloneDeep(ScheduleServiceItemIconStatusPartnersConstants[schedule.ltrsStatus])
    : _.cloneDeep(ScheduleServiceItemIconStatusConstants[scheduleStatus]);

  let icon = _.get(iconAndStatus, 'icon');
  let status = _.get(iconAndStatus, 'status');

  if (!icon || !status) {
    iconAndStatus = _.cloneDeep(ScheduleServiceItemIconStatusConstants.fallback);
    icon = _.get(iconAndStatus, 'icon');
    status = _.get(iconAndStatus, 'status');

    lsErrorService.log({
      error: {
        message: `Schedule status and icon info not present for ${scheduleStatus} using fallback`,
        level: 'info',
        extra: {
          schedule,
        },
      },
    });
  }

  const startDate = _.get(schedule, status.startDatePath);
  const endDate = _.get(schedule, status.endDatePath);
  let statusText = status.text;

  // if there is a valid start and end date, as well as append string,
  // add it to the status text so long as start and end are not the same day
  if (status.appendOnMultiDate && startDate && endDate && startDate !== endDate) {
    statusText += status.appendOnMultiDate;
  }

  return {
    icon: { ...icon, type: icon.name },
    statusText,
    startDate,
    endDate,
  };
};
// eslint-disable-next-line import/prefer-default-export
export const lsScheduleServiceItemHelpers = { getScheduleServiceItemDisplayValues };
